<section class="status-section" aria-live="polite">
  @if (loading()) {
    <p>Loading API key status records...</p>
  } @else if (errorMessage()) {
    <p class="error-message">{{ errorMessage() }}</p>
  } @else if (rows().length === 0) {
    <p>No API key status records found.</p>
  } @else {
    <div class="status-controls">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search by username</mat-label>
        <input
          matInput
          [formControl]="searchControl"
          type="search"
          autocomplete="off" />
      </mat-form-field>

      <mat-button-toggle-group
        [value]="selectedFilter()"
        aria-label="Filter API key status records">
        <mat-button-toggle value="all" (click)="setStatusFilter('all')">All</mat-button-toggle>
        <mat-button-toggle value="active" (click)="setStatusFilter('active')">Active</mat-button-toggle>
        <mat-button-toggle value="inactive" (click)="setStatusFilter('inactive')">Inactive</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    @if (filteredRows().length === 0) {
      <p>No matching API key records found.</p>
    } @else {
      <table class="status-table">
        <caption class="sr-only">API key status records grouped by user</caption>
        <thead>
          <tr>
            <th scope="col">Username</th>
            <th scope="col">API Keys</th>
            <th scope="col">Details</th>
          </tr>
        </thead>
        <tbody>
          @for (row of filteredRows(); track row.userId) {
            <tr>
              <th scope="row">{{ row.userName }}</th>
              <td>{{ row.apiKeyCount }}</td>
              <td>
                <button
                  mat-stroked-button
                  type="button"
                  [attr.aria-expanded]="isExpanded(row.userId)"
                  [attr.aria-controls]="'api-key-status-details-' + row.userId"
                  (click)="toggleExpanded(row.userId)">
                  {{ isExpanded(row.userId) ? 'Hide details' : 'View details' }}
                </button>
              </td>
            </tr>

            @if (isExpanded(row.userId)) {
              <tr>
                <td class="details-cell" colspan="3">
                  <div [id]="'api-key-status-details-' + row.userId" class="details-content">
                    @for (detail of row.details; track detail.id) {
                      <article class="detail-card">
                        <dl>
                          <dt>Status</dt>
                          <dd>{{ detail.status }}</dd>

                          <dt>Expiration Date</dt>
                          <dd>
                            @if (detail.expirationDate) {
                              {{ detail.expirationDate | date: 'mediumDate' }}
                            } @else {
                              N/A
                            }
                          </dd>

                          <dt>Supported Systems</dt>
                          <dd>{{ formatSupportedSystems(detail.supportedSystems) }}</dd>

                          <dt>Reason for Inactive Status</dt>
                          <dd>{{ detail.reason || 'N/A' }}</dd>
                        </dl>
                      </article>
                    }
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    }
  }
</section>


